//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getPaiGongWorkOrders} from '../../../../api/workOrder'
import PageSearchHeader from "../componets/page-search-header";
import WorkOrderCell from "../componets/work-order-cell";

export default {
    name: "page-paiGong-view",
    components: {WorkOrderCell, PageSearchHeader},
    data() {
        return {
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            searchInput: {}
        }
    },
    props: {},
    methods: {
        workDetail(item) {
            this.$router.push({
                name: 'workSheetDetail',
                params: {
                    id: item.id
                }
            })
        },
        handleSearch(data) {
            this.searchInput = data;
            this.onRefresh();
        },
        onRefresh() {
            this.pageIndex = 1;
            this.getWorkOrders();
        },
        onLoad() {
            this.pageIndex++;
            this.getWorkOrders()
        },
        getWorkOrders() {
            const vm = this;
            this.refreshing = this.pageIndex === 1;
            this.loading = this.pageIndex > 1;
            // const page = {
            //     maxResultCount: this.pageSize,
            //     skipCount: (this.pageIndex - 1) * this.pageSize,
            //     filter: this.searchInput.filter
            // };
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.pageIndex - 1) * this.pageSize
            getPaiGongWorkOrders(this.searchInput).then((res) => {
                if (this.pageIndex === 1) {
                    vm.list = [];
                }
                vm.list.push(...res.data.result.items);
                if (res.data.result.items.length < this.pageSize) {
                    vm.finished = true;
                } else {
                    vm.finished = false;
                }
            }).then(() => {
                vm.refreshing = false;
                vm.loading = false;
            }).catch((error) => {
                vm.refreshing = false;
                vm.loading = true;
            }).finally(() => {
                // this.refreshing = false;
                // this.loading = true;
            });
        },

        onSearch() {
            this.onRefresh()
        },

        onCancel() {
            this.searchInput = {
                filter: ''
            }
            this.onRefresh()
        }
    },
    created() {

    }
}
